import { Box, Card, Grid, Stack, Tab, TabContext, Typography, getSpacing } from "@compass/core";
import Tabs from "@mui/material/Tabs";
import {
  AprEocResponse,
  AprRequestFilter,
  AprResponseActivitiesAndServices,
  AprSssResponse as AprResponseModel,
  AprSection,
  AprSectionId,
  AprSectionItemId,
} from "generated/openApi";

import "moment-timezone";
import { useState } from "react";
import { AprEocTabA } from "./Tabs/AprEocTabA";
import { AprEocTabB } from "./Tabs/AprEocTabB";
import { AprEocTabC } from "./Tabs/AprEocTabC";
import { AprEocTabD } from "./Tabs/AprEocTabD";
import { AprEocTabE } from "./Tabs/AprEocTabE";
import { AprEocTabF } from "./Tabs/AprEocTabF";
import { AprEocTabG } from "./Tabs/AprEocTabG";
import { AprEocTabH } from "./Tabs/AprEocTabH";
import { AprEocTabIIIA } from "./Tabs/AprEocTabIIIA";
import { AprEocTabIVA } from "./Tabs/AprEocTabIVA";
import { AprEocTabIVB } from "./Tabs/AprEocTabIVB";
import { AprEocTabIVC } from "./Tabs/AprEocTabIVC";
import { AprEocTabIVD } from "./Tabs/AprEocTabIVD";
import { AprEocTabIVE } from "./Tabs/AprEocTabIVE";
import { AprEocTabCpp } from "./Tabs/AprEocTabCPP";
import { AprEocTabIIIB } from "./Tabs/AprEocTabIIIB";

export type AprEocTab = "A" | "B" | "C" | "D" | "E" | "F" | "G" | "H" | "CPP1" | "Section II" | "Section III" | "III-A" | "III-B" | "Section IV" | "IV-A" | "IV-B" | "IV-C" | "IV-D" | "IV-E";

export const AprEocBody = (props: {
  filter: AprRequestFilter;
  response: AprEocResponse;
  aprSections: AprSection[];
  selectedSectionItemIds: number[];
}) => {
  const [currentTab, setCurrentTab] = useState<AprEocTab>("A");
  const availableTabs: AprEocTab[] = ["Section II", "A", "B", "C", "D", "E", "F", "G", "H", "CPP1", "Section III", "III-A", "III-B", "Section IV", "IV-A", "IV-B", "IV-C", "IV-D", "IV-E"];

  const getLabel = (tab: AprEocTab): string => {
    if (tab == "III-A") return "A";
    if (tab == "III-B") return "B";
    if (tab == "IV-A") return "A";
    if (tab == "IV-B") return "B";
    if (tab == "IV-C") return "C";
    if (tab == "IV-D") return "D";
    if (tab == "IV-E") return "E";
    return tab;
  }

  return (
    <Card style={{ height: "100%"}}>
      <Grid container spacing="sm" style={{ height: "100%"}}>
        <Grid item xs={1}>
          <TabContext value={currentTab || "A"}>
            <Tabs
              orientation="vertical"
              onChange={(e, value) => setCurrentTab(value)}
              value={currentTab}
              variant="standard"
              scrollButtons
              allowScrollButtonsMobile
            >
              {availableTabs?.map((tab) => 
                (tab == "Section II" || tab == "Section III" || tab == "Section IV") ? <Box key={tab} sx={{ my: 1, px: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {tab}
                </Typography>
              </Box>
              :
                <Tab key={tab} label={getLabel(tab)} value={tab} />
              )}
            </Tabs>
          </TabContext>
        </Grid>
        <Grid item xs={11}>
          {currentTab == "A" && <AprEocTabA data={props.response.tabA} properties={props.response.properties} />}
          {currentTab == "B" && <AprEocTabB data={props.response.tabB} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "C" && <AprEocTabC data={props.response.tabC} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "D" && <AprEocTabD data={props.response.tabD} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "E" && <AprEocTabE data={props.response.tabE} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "F" && <AprEocTabF data={props.response.tabF} properties={props.response.properties} />}
          {currentTab == "G" && <AprEocTabG data={props.response.tabG} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "H" && <AprEocTabH data={props.response.tabH} properties={props.response.properties} />}
          {currentTab == "CPP1" && <AprEocTabCpp data={props.response.tabCpp} properties={props.response.properties} />}
          {currentTab == "III-A" && <AprEocTabIIIA data={props.response.tab3A} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "III-B" && <AprEocTabIIIB data={props.response.tab3B} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-A" && <AprEocTabIVA data={props.response.tab4A} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-B" && <AprEocTabIVB data={props.response.tab4B} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-C" && <AprEocTabIVC data={props.response.tab4C} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-D" && <AprEocTabIVD data={props.response.tab4D} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-E" && <AprEocTabIVE data={props.response.tab4E} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
        </Grid>
      </Grid>
    </Card>
  );
};

